module.exports = __webpack_public_path__ + "media/images/icons/line_gainfriends_2dbarcodes-42d920eef8982dfaa35d9e6f68a2353a.png";